import { useState } from 'react';
import { CONFIG_STATUS_NAME } from '../../../../types/product.configuration.types';
import { getAdditionalServiceDisplayElementsBord } from '../../../../utils/logisticServices.utils';
import ConfigurationCommentsModal from 'components/NudosComponents/ConfigurationCommentsModal/ConfigurationCommentsModal';
import { statusVariants } from 'components/NudosComponents/BordStatus/BordStatus.type';
import { renderVariantServicesStatus } from 'constants/constants';
import PendingActionStatus from './PendingActionStatus/PendingActionStatus';
import BordTooltip from 'components/BordTooltip/BordTooltip';
import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { markAdditionalServiceNotCompletedAlertViewed } from 'services/services';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import BordStatus from 'components/NudosComponents/BordStatus/BordStatus';
import { getAdditionalAction } from 'utils/configurations';
import { CONFIG_ADDITIONAL_ACTION_ID, IadditionalServiceDataForToolLogistics } from 'types/product.configuration.types';
import './NudosAdditionalServiceStatus.scss';

const NudosAdditionalServiceStatus = ({
  additionalServiceData,
  callToActionCallback,
  isAdditionalSettingsInOrders
}: {
  additionalServiceData: IadditionalServiceDataForToolLogistics;
  callToActionCallback?: () => void;
  isAdditionalSettingsInOrders?: boolean;
}) => {
  const [showConfigurationCommentsModal, setShowConfigurationCommentsModal] = useState(false);

  const {
    id: additionalServiceProductId,
    comments,
    configData,
    configClassId,
    status: additionalServiceStatus,
    additionalActions
  } = additionalServiceData || {};

  const { statusName, statusViewedByUserId } = additionalServiceStatus || {};
  if (!additionalServiceData) {
    return <div>No hay datos disponibles</div>;
  }

  const { text, icon, status } = getAdditionalServiceDisplayElementsBord(additionalServiceData);
  const enrollmentAction = getAdditionalAction(additionalActions, CONFIG_ADDITIONAL_ACTION_ID.CONFIRM_ENROLLMENT);

  const serviceIsToBeCompleted = statusName === CONFIG_STATUS_NAME.TO_COMPLETE;
  const serviceWasNotCompleted = statusName === CONFIG_STATUS_NAME.NOT_COMPLETED;
  const hasEnrollmentPending = enrollmentAction && enrollmentAction.confirmedAt === null;

  const checkServiceEvidenceModalIsDisabled = !statusName || serviceIsToBeCompleted;

  const markEvidenceViewed = async () => {
    if (!additionalServiceProductId || statusViewedByUserId) return;
    try {
      await markAdditionalServiceNotCompletedAlertViewed(additionalServiceProductId);
    } catch (error) {
      displayErrorNotification();
    }
  };

  const handleCheckServiceEvidenceModal = () => {
    if (checkServiceEvidenceModalIsDisabled) return;
    if (serviceWasNotCompleted) markEvidenceViewed();
    callToActionCallback?.();
  };

  const openConfigurationCommentsModal = () => setShowConfigurationCommentsModal(true);
  const closeConfigurationCommentsModal = () => setShowConfigurationCommentsModal(false);

  return (
    <div className="nudosAdditionalServiceStatus">
      <div className="containerIconServiceName">
        {icon}
        <div className="serviceName">{text}</div>
      </div>
      {!!comments && (
        <div className="commentsSection cursor-pointer" onClick={openConfigurationCommentsModal}>
          <BordTooltip position="bottom" message="Ver configuración">
            <BordOneToneIcon variant="messageCircle" customWidth="12px" />
          </BordTooltip>
        </div>
      )}
      <div className="divider" />
      {hasEnrollmentPending ? (
        <PendingActionStatus
          status={status}
          actionText="Estado del Enrollment pendiente por confirmar"
          onClick={handleCheckServiceEvidenceModal}
        />
      ) : (
        <BordStatus
          variant={renderVariantServicesStatus({ variant: statusName as string as statusVariants }) as statusVariants}
          renderJSX={
            <div className="customBordStatusContainer" onClick={() => handleCheckServiceEvidenceModal()}>
              <span>{status}</span>
            </div>
          }
        />
      )}
      {showConfigurationCommentsModal && comments && (
        <ConfigurationCommentsModal
          closeModalCallback={closeConfigurationCommentsModal}
          comments={comments || ''}
          configData={configData}
          configClassId={configClassId}
          isAdditionalSettingsInOrders={isAdditionalSettingsInOrders}
        />
      )}
    </div>
  );
};

export default NudosAdditionalServiceStatus;
